import PreferencesViewSwitch from "./PreferencesViewSwitch"
export default PreferencesViewSwitch
